import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const storedResultRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.view.route,
      lazy: () => import("@pages/panelPages/storedResult/viewStoredResult"),
      loader: ({ request }) => {
        /* const { patient_id, patient_type } =
          params as IViewStoredResultRouteParams*/

        useUIStore
          .getState()
          .setPage(request, "pageTitle.view-stored-result", [], "index");
        return {};
      },
    },
    permissions: [
      "doctor",
      "patient",
      "admin",
      "staff",
      "super-admin",
      "local-admin",
    ],
  },
  {
    route: {
      path: path.viewAppointment.route,
      lazy: () => import("@pages/panelPages/storedResult/viewStoredResult"),
      loader: ({ request }) => {
        /* const { patient_id, patient_type, appointment_id } =
          params as IViewAppointmentStoredResultRouteParams*/

        useUIStore
          .getState()
          .setPage(request, "pageTitle.view-stored-result", [], "index");
        return {};
      },
    },
    permissions: [
      "doctor",
      "patient",
      "admin",
      "staff",
      "super-admin",
      "local-admin",
    ],
  },
  {
    route: {
      path: path.patientList.route,
      lazy: () =>
        import(
          "@pages/panelPages/patientStoredResultListPage/patientStoredResultListPage"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.stored_result", [], "index", "main");
        return {};
      },
    },
    permissions: ["patient"],
  },
  {
    route: {
      path: path.selfReport.route,
      lazy: () => import("@pages/panelPages/selfReport/selfReportPage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.selfReport", [], "edit");
        return {};
      },
    },
    permissions: ["patient"],
  },
];
